module.exports = __webpack_public_path__ + "img/icon_03.3725c4ba.png";